import { API_PATHS } from '@alphadesk/web/contract.ts';
import { PAGES } from '@alphadesk/web/links.ts';
import { Eye } from 'lucide-react';
import { useState } from 'react';
import { act, useWrite } from '../lib/act.ts';
import { Button } from './primitives/button.tsx';

/** A whole page load, so no read, socket or provider keeps the console it left. */
function useViewing(action: object, to: string) {
  const { run, busy } = useWrite();
  const [refused, setRefused] = useState<string | null>(null);
  const go = () =>
    void run(() => act(API_PATHS.act, action)).then((outcome) => {
      if (outcome.ok) window.location.assign(to);
      else setRefused(outcome.violations.join(' '));
    });
  return { go, busy, refused };
}

export function ViewingBanner({ name }: { name: string }) {
  const { go, busy, refused } = useViewing({ do: 'stop-viewing-as' }, PAGES.users);
  return (
    <div role="status" className="border-b border-warn/20 bg-warn/10 py-2">
      <div className="rail flex flex-wrap items-center gap-x-3 gap-y-1.5">
        <p className="flex min-w-0 flex-1 items-center gap-2 text-xs leading-relaxed text-warn">
          <Eye aria-hidden className="size-3.5 shrink-0" />
          <span>
            Viewing the console as <span className="font-medium">{name}</span>. Nothing can be
            changed until you stop.
            {refused && ` ${refused}`}
          </span>
        </p>
        <Button size="sm" busy={busy} onClick={go}>
          Stop viewing
        </Button>
      </div>
    </div>
  );
}

export function ViewAsButton({ memberId }: { memberId: number }) {
  const { go, busy, refused } = useViewing({ do: 'view-as', memberId }, PAGES.home);
  return (
    <Button busy={busy} onClick={go} title={refused ?? 'See the console as this person sees it'}>
      View as
    </Button>
  );
}
